var _defs, _rect, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bases",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dcdbdd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file.shell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15,
    y: 19,
    width: 9,
    height: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16 16 15.34 16.66 14.59 17.41 14 18 11 21 9.59 19.59 13.17 16 9.59 12.41 11 11 14.59 14.59 16 16"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,26V12H18V6H8V26ZM6,26V6A1.91,1.91,0,0,1,7.93,4H19.28L26,10V26a2,2,0,0,1-2.07,2h-16A1.91,1.91,0,0,1,6,26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesh);
export default __webpack_public_path__ + "static/media/file.sh.10e3228d79998aa6dda3dd1d941569e8.svg";
export { ForwardRef as ReactComponent };